import React, { useState } from 'react';
import {
  Chip,
  Popover,
  Box,
  TextField,
  Button,
} from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

import styles from './DateRangePickerStyles';

const DateRangePicker = ({ dateRange, setDateRange, label = 'Date Range' }) => {
  const [anchorPos, setAnchorPos] = useState(null);
  const [draftRange, setDraftRange] = useState(dateRange);

  const openPopover = (e) => {
    setDraftRange(dateRange); 
    setAnchorPos({ top: e.clientY, left: e.clientX });
  };

  const closePopover = () => setAnchorPos(null);

  const applyDate = () => {
    setDateRange(draftRange); 
    closePopover();
  };

  const clearDate = () => {
    setDraftRange({ start: '', end: '' });
    setDateRange({ start: '', end: '' });
    closePopover();
  };

  const formatDateLabel = () => {
    const { start, end } = dateRange;
    if (start && end) return `${start} – ${end}`;
    if (start) return `From ${start}`;
    if (end) return `To ${end}`;
    return 'Select Date Range';
  };

  const isActive = Boolean(dateRange.start || dateRange.end);

  return (
    <>
      <Chip
        icon={<CalendarTodayIcon />}
        label={formatDateLabel()}
        onClick={openPopover}
        sx={isActive ? styles.activeChip : styles.chip}
      />

      <Popover
        open={!!anchorPos}
        anchorReference="anchorPosition"
        anchorPosition={anchorPos}
        onClose={closePopover}
      >
        <Box sx={styles.popoverContent}>
          <TextField
            label="Start Date"
            type="date"
            value={draftRange.start}
            onChange={(e) =>
              setDraftRange((prev) => ({ ...prev, start: e.target.value }))
            }
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="End Date"
            type="date"
            value={draftRange.end}
            onChange={(e) =>
              setDraftRange((prev) => ({ ...prev, end: e.target.value }))
            }
            InputLabelProps={{ shrink: true }}
          />

          <Box sx={styles.dateApplyContainer}>
            <Button
              size="small"
              variant="text"
              onClick={clearDate}
              sx={styles.clearButton}
            >
              Clear
            </Button>
            <Button
              size="small"
              variant="contained"
              sx={styles.dateApplyButton}
              onClick={applyDate}
            >
              Apply
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default DateRangePicker;
